import styled from "styled-components";
const CategoryPageDisplay = styled.div`
	// my css here
`;	export default CategoryPageDisplay;
